module.exports = __webpack_public_path__ + "static/uni-of-melbourne.logo-5298b119af4cb58ccf93b82b77d35409.png";